module.exports = __webpack_public_path__ + "static/img/fbbl.a353596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/fbbl.jpg
// module id = dk6z
// module chunks = 0